"use es6";

export function isObject(x) {
  return x != null && typeof x === 'object';
}